import React from 'react';

function Privacy() {
  return (
    <div className="p-10 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p>
        This is a dummy privacy policy for Learn&Grow. We respect your privacy 
        and ensure your data is protected. Your information is securely stored 
        and will not be shared with third parties.
      </p>
    </div>
  );
}

export default Privacy;
